// extracted by mini-css-extract-plugin
module.exports = {"parent":"HolidayConfiguration_parent__2u0nZ"};